import axios from "axios";
import base64 from "base-64";
import ENV from "../env";

const options1 = {
    headers: {
        'Content-Type': 'application/json',
        'Security': ENV.REACT_APP_SECURE_TOKEN
    }
};

    const forgotPwdApi = async (body) => {

    const response1 = await axios.post(`${ENV.LOCUSB_API}/UserSecureToken`, {userId: body.userId}, options1)

    if (response1.data.success === 'false') {
        return response1.data.errorMsg
    }
    else {
        if(response1.data.success === 'true'){
        await localStorage.setItem('userId', response1.data.data.userId);
        await localStorage.setItem('sToken', response1.data.data.sToken);
        await localStorage.setItem('email', body.userId);

        let userId = await localStorage.getItem('userId');
        let sToken = await localStorage.getItem('sToken');
        let header = await base64.encode(`${userId}:${sToken}`);
        let security = await `Basic ${header}`;

        const options = {
            headers: {
                'Content-Type': 'application/json',
                'Security': security,
                'Accept': 'application/json'
            }
        };

        const response = await axios.post(`${ENV.LOCUSB_API}/SendCode`, body, options)

        if (response.data.success === 'false') {
            return response.data.errorMsg
        }
        else {
            return response.data;
        }
    }
    }
}

export default forgotPwdApi;
